import { NavLink } from 'react-router-dom';

const sections = [
  {
    title: 'Principal',
    items: [
      { to: '/dashboard', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
      { to: '/postes', label: 'Postes', icon: 'M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z' },
      { to: '/mesures', label: 'Mesures', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z', lock: true },
    ],
  },
  {
    title: 'Serveur BD',
    items: [
      { to: '/db', label: 'Base de données', icon: 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4' },
      { to: '/jobs', label: 'Jobs', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
    ],
  },
  {
    title: 'Services',
    items: [
      { to: '/ingest', label: 'Synchronisation', icon: 'M13 10V3L4 14h7v7l9-11h-7z', status: 'up' },
      { to: '/json', label: 'Réception JSON', icon: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4', status: 'up' },
      // Masqué tant que le service MQTT n'est pas exploité. La page et sa route
      // restent en place : retirer `hidden` suffit à la réafficher.
      { to: '/mqtt', label: 'Traitement MQTT', icon: 'M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0', status: 'down', hidden: true },
      { to: '/annotations', label: 'Annotations', icon: 'M7 7h10M7 11h6m-6 4h10M5 3h14a2 2 0 012 2v10l-4 4H5a2 2 0 01-2-2V5a2 2 0 012-2z' },
      { to: '/upd-weewx', label: 'Upd WeeWX', icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' },
      { to: '/incidents', label: 'Incidents', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z', badge: 7 },
    ],
  },
  {
    title: 'Système',
    items: [
      { to: '/audit', label: 'Audit', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' },
      { to: '/users', label: 'Utilisateurs', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z', lock: true },
      { to: '/settings', label: 'Paramètres', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065zM15 12a3 3 0 11-6 0 3 3 0 016 0z' },
    ],
  },
];

export default function Sidebar() {
  return (
    <aside className="bg-sidebar bg-slate-50 border-r border-border w-14 flex flex-col items-center py-3 gap-1 shrink-0">
      <img src="https://www.meteor-oi.re/wp-content/uploads/2024/08/MeteoR-OI_Logo.png" alt="MétéoR-OI" className="h-8 mb-2" />
      {sections.map((section, idx) => (
        <div key={section.title} className="flex flex-col items-center gap-1 w-full">
          {idx > 0 && <div className="w-full border-t border-border my-1" />}
          {section.items.filter((item) => !('hidden' in item && item.hidden)).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              title={item.label}
              aria-label={item.label}
              className={({ isActive }) =>
                `relative w-10 h-10 rounded-lg flex items-center justify-center ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-accent'
                }`
              }
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d={item.icon} />
              </svg>
              {'status' in item && item.status && (
                <span
                  className={`absolute top-1 right-1 w-1.5 h-1.5 rounded-full ${
                    item.status === 'up' ? 'bg-green-500' : item.status === 'down' ? 'bg-slate-400' : 'bg-amber-500'
                  }`}
                />
              )}
              {'badge' in item && item.badge && (
                <span className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-destructive text-white text-[9px] font-bold flex items-center justify-center">
                  {item.badge}
                </span>
              )}
              {'lock' in item && item.lock && (
                <span className="absolute -bottom-0.5 -right-0.5 text-[8px]">🔒</span>
              )}
            </NavLink>
          ))}
        </div>
      ))}
      <div className="flex-1" />
    </aside>
  );
}
